<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal-form-viaje-export-excel"
      style="background-color: #00000082"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Generar Listado Viajes Excel</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="row">
              <div class="col-md-5 mb-3">
                <div class="card shadow-sm border">
                  <div class="card-header">
                    <h6 class="mb-0">Columnas</h6>
                  </div>
                  <div class="card-body">
                    <div
                      class="custom-control custom-checkbox mb-1"
                      v-for="item in columnasConfig"
                      :key="item.key"
                    >
                      <input
                        :id="`col-${item.key}`"
                        type="checkbox"
                        class="custom-control-input"
                        v-model="columnas[item.key]"
                      />
                      <label
                        class="custom-control-label"
                        :for="`col-${item.key}`"
                      >
                        {{ item.label }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-7 mb-3">
                <div class="card shadow-sm border">
                  <div class="card-header">
                    <h6 class="mb-0">Filtros</h6>
                  </div>
                  <div class="card-body">
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label
                          >Fecha inicial viaje
                          <span class="text-danger">*</span></label
                        >
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="filtros.fecha_inicial"
                          @input="validaRangoFechasViaje"
                        />
                        <small class="text-muted"
                          >Sobre <code>fecha_inicial</code> del viaje.
                          Obligatorio; máx. 30 días respecto a fecha
                          final.</small
                        >
                      </div>
                      <div class="form-group col-md-6">
                        <label
                          >Fecha final viaje
                          <span class="text-danger">*</span></label
                        >
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="filtros.fecha_final"
                          @input="validaRangoFechasViaje"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label># Viaje</label>
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          v-model="filtros.viaje_id"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label># Programación</label>
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          v-model="filtros.programacion_id"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label>Vehículo</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.vehiculo"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label>Remolque</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.remolque"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label>Conductor</label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          class="form-control form-control-sm p-0"
                          v-model="filtros.conductor_id"
                          label="nombre"
                          :options="listasForms.conductores"
                          :reduce="(item) => item.id"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-6">
                        <label>Transportadora</label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          class="form-control form-control-sm p-0"
                          v-model="filtros.transportadora_id"
                          label="razon_social"
                          :options="listasForms.empresas"
                          :reduce="(item) => item.id"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-6">
                        <label>Ruta</label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          class="form-control form-control-sm p-0"
                          v-model="filtros.ruta_id"
                          label="nombre"
                          :options="listasForms.rutas"
                          :reduce="(item) => item.id"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-6">
                        <label>Sitio cargue</label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          class="form-control form-control-sm p-0"
                          v-model="filtros.sitio_cargue_id"
                          label="nombre"
                          :options="listasForms.sitios"
                          :reduce="(item) => item.id"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-6">
                        <label>Sitio descargue</label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          class="form-control form-control-sm p-0"
                          v-model="filtros.sitio_descargue_id"
                          label="nombre"
                          :options="listasForms.sitios"
                          :reduce="(item) => item.id"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-6">
                        <label>Estado</label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          class="form-control form-control-sm p-0"
                          v-model="filtros.estado"
                          label="descripcion"
                          :options="listasForms.estados"
                          :reduce="(item) => item.numeracion"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-6">
                        <label>Fecha cita cargue</label>
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="filtros.fecha_cita_cargue"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label>Fecha turne</label>
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="filtros.fecha_turne"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-sm bg-navy mr-2"
                @click="exportExcel"
              >
                Generar Listado
                <i class="fas fa-file-download"></i>
              </button>
              <button
                type="button"
                class="btn btn-sm btn-danger"
                @click="limpiarModal"
              >
                Limpiar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import Loading from "../../../../components/Loading";

export default {
  name: "ViajeExportExcel",
  components: {
    Loading,
    vSelect,
  },
  data() {
    return {
      cargando: false,
      columnasConfig: [
        { key: "fecha_programacion", label: "Fecha de Programación" },
        { key: "viaje_id", label: "Viaje" },
        { key: "transportadora", label: "Transportadora" },
        { key: "vehiculo", label: "Vehículo" },
        { key: "remolque", label: "Remolque" },
        { key: "conductor", label: "Conductor" },
        { key: "cedula_conductor", label: "Cedula" },
        { key: "sitio_cargue", label: "Sitio cargue" },
        { key: "sitio_descargue", label: "Sitio descargue" },
        { key: "programacion_id", label: "ID Programación" },
        { key: "ruta", label: "Ruta" },
        { key: "fecha_turne", label: "Fecha turne" },
        { key: "fecha_cita_cargue", label: "Fecha cita cargue" },
        { key: "modo_creacion_viaje", label: "Modo Creación de Viaje" },
        { key: "estado", label: "Estado" },
        { key: "inspeccion", label: "Fecha Expedición" },
        { key: "tipo_inspeccion", label: "Fecha Salida" },
        { key: "tipo_solicitud", label: "Hora cita cargue" },
        { key: "observacion", label: "Hora turne" },
      ],
      columnas: {
        fecha_programacion: true,
        viaje_id: true,
        transportadora: true,
        vehiculo: true,
        remolque: true,
        conductor: true,
        cedula_conductor: true,
        sitio_cargue: true,
        sitio_descargue: true,
        programacion_id: true,
        ruta: true,
        fecha_turne: true,
        fecha_cita_cargue: true,
        modo_creacion_viaje: true,
        estado: true,
        inspeccion: true,
        tipo_inspeccion: true,
        tipo_solicitud: true,
        observacion: true,
      },
      filtros: {
        fecha_inicial: null,
        fecha_final: null,
        viaje_id: null,
        programacion_id: null,
        vehiculo: null,
        remolque: null,
        conductor_id: null,
        transportadora_id: null,
        ruta_id: null,
        sitio_cargue_id: null,
        sitio_descargue_id: null,
        estado: null,
        fecha_cita_cargue: null,
        fecha_turne: null,
      },
    };
  },
  computed: {
    listasForms() {
      return this.$parent?.listasForms || {};
    },
  },
  methods: {
    validaRangoFechasViaje() {
      if (!this.filtros.fecha_inicial || !this.filtros.fecha_final) {
        return true;
      }
      const ini = new Date(this.filtros.fecha_inicial);
      const fin = new Date(this.filtros.fecha_final);
      if (ini > fin) {
        this.$swal({
          icon: "error",
          title: "La fecha inicial no puede ser mayor que la fecha final.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        this.filtros.fecha_final = null;
        return false;
      }
      const diffMs = fin.getTime() - ini.getTime();
      const diffDias = diffMs / (1000 * 60 * 60 * 24);
      if (diffDias > 30) {
        this.$swal({
          icon: "error",
          title: "El rango no puede ser mayor a 30 días.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        this.filtros.fecha_final = null;
        return false;
      }
      return true;
    },

    limpiarModal() {
      this.columnas = {
        fecha_programacion: true,
        viaje_id: true,
        transportadora: true,
        vehiculo: true,
        remolque: true,
        conductor: true,
        cedula_conductor: true,
        sitio_cargue: true,
        sitio_descargue: true,
        programacion_id: true,
        ruta: true,
        fecha_turne: true,
        fecha_cita_cargue: true,
        modo_creacion_viaje: true,
        estado: true,
        inspeccion: true,
        tipo_inspeccion: true,
        tipo_solicitud: true,
        observacion: true,
      };
      this.filtros = {
        fecha_inicial: null,
        fecha_final: null,
        viaje_id: null,
        programacion_id: null,
        vehiculo: null,
        remolque: null,
        conductor_id: null,
        transportadora_id: null,
        ruta_id: null,
        sitio_cargue_id: null,
        sitio_descargue_id: null,
        estado: null,
        fecha_cita_cargue: null,
        fecha_turne: null,
      };
    },

    exportExcel() {
      if (!this.filtros.fecha_inicial || !this.filtros.fecha_final) {
        this.$swal({
          icon: "error",
          title: "Indique fecha inicial y fecha final del viaje.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }
      if (!this.validaRangoFechasViaje()) {
        return;
      }
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/hidrocarburos/viajes/export",
        data: {
          columnas: this.columnas,
          filtros: this.filtros,
        },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          if (data && data.url) {
            location.href = data.url;
            return;
          }
          this.$swal({
            icon: "warning",
            title: "No se recibió archivo para descargar",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          const msg =
            e.response && e.response.data && e.response.data.message
              ? e.response.data.message
              : "Ocurrió un error al exportar.";
          this.$swal({
            icon: "error",
            title: msg,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },
};
</script>
